import React, { useState } from 'react';
import { Modal, Input, Alert, List } from 'antd';

const PublishModal = ({ open, onCancel, onConfirm, validation, loading }) => {
  const [note, setNote] = useState('');

  return (
    <Modal
      title="Publish flow"
      open={open}
      onCancel={onCancel}
      onOk={() => onConfirm(note)}
      okText="Publish"
      confirmLoading={loading}
      okButtonProps={{ disabled: validation && !validation.valid }}
    >
      {validation && !validation.valid && (
        <Alert
          type="error"
          message="Fix validation errors before publishing"
          style={{ marginBottom: 12 }}
        />
      )}
      {validation?.errors?.length > 0 && (
        <List
          size="small"
          dataSource={validation.errors}
          renderItem={(e) => (
            <List.Item>{e.message || JSON.stringify(e)}</List.Item>
          )}
          style={{ marginBottom: 12, maxHeight: 120, overflow: 'auto' }}
        />
      )}
      <Input.TextArea
        rows={3}
        placeholder="Version note (optional)"
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />
    </Modal>
  );
};

export default PublishModal;
